import { FC, ReactNode } from 'react';
import { CourseListProvider } from '@new/common/contexts/CourseListContext';
import { CourseStatusTabs } from './CourseStatusTabs';
import { CourseSearchBar } from './CourseSearchBar';
import { CourseGrid } from './CourseGrid';
import { CourseWithProgress } from '@teachur/http-client';

interface CourseListProps {
  courses: CourseWithProgress[];
  degreeId?: number;
  header?: ReactNode;
  showBanner?: boolean;
  banner?: ReactNode;
  readOnly?: boolean;
}

export const CourseList: FC<CourseListProps> = ({
  courses,
  degreeId,
  header,
  showBanner = false,
  banner,
  readOnly,
}) => {
  return (
    <CourseListProvider courses={courses} degreeId={degreeId}>
      <div className="flex flex-col gap-5 w-full">
        {header}
        {showBanner && banner}
        <CourseStatusTabs readOnly={readOnly} />
        <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between">
          <CourseSearchBar />
        </div>
        <CourseGrid readOnly={readOnly} />
      </div>
    </CourseListProvider>
  );
};
